export default "__VITE_ASSET__5a382bac__"